import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '20px',
    width: '371px'
  },
  footerList: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  itemSelected: {
    outline: `2px ${theme.palette.primary.main} solid`,
  },
  logo: {
    marginBottom: '30%',
  },
  button: {
    fontFamily: 'BancoDoBrasil Titulos',

  }
}));

export const useListItemStyles = makeStyles(() => ({
  root: {
    boxShadow:
      "0px 1px 1px rgba(0, 0, 0, 0.18), 0px 0px 1px rgba(0, 0, 0, 0.25);",
    borderRadius: 4,
    cursor: "pointer",
  },
}));

export const useListStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gridGap: 8,
    marginTop: 10,
  },
}));

export default useStyles;